import { createTheme } from '@mui/material/styles';

/**
 * Laboklin MyLab visual identity.
 *
 * Values were read off the live portal (app.laboklin.com), which is a
 * Bootstrap 4 application: flat surfaces with hairline borders rather than
 * shadows, 15px system-stack body text, square-ish 4px corners. Applied by
 * nesting a ThemeProvider around the /mylab route only, so the rest of the
 * app keeps the GekkoVet theme.
 */

export const LABOKLIN_RED = 'rgb(229, 30, 30)';
export const LABOKLIN_BORDER = 'rgba(0, 0, 0, 0.125)';
export const LABOKLIN_PAGE_BG = 'rgb(233, 234, 236)';
export const LABOKLIN_APPBAR_HEIGHT = 64;

const FONT_STACK = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  '"Noto Sans"',
  'sans-serif',
].join(',');

export const laboklinTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: LABOKLIN_RED, contrastText: '#ffffff' },
    background: { default: LABOKLIN_PAGE_BG, paper: '#ffffff' },
    text: { primary: '#212529', secondary: '#6c757d' },
    divider: LABOKLIN_BORDER,
  },
  typography: {
    fontFamily: FONT_STACK,
    fontSize: 15,
    h1: { fontSize: '2rem', fontWeight: 600 },
    h2: { fontSize: '1.6rem', fontWeight: 600 },
    h3: { fontSize: '1.35rem', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  // Bootstrap's 4px radius, not MUI's 8px - a visibly different silhouette.
  shape: { borderRadius: 4 },
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { border: `1px solid ${LABOKLIN_BORDER}`, backgroundImage: 'none' },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0, color: 'inherit' },
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#212529',
          borderBottom: `1px solid ${LABOKLIN_BORDER}`,
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontSize: 15, borderRadius: 4 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '0.75rem',
          fontSize: 15,
          borderBottom: '1px solid #dee2e6',
        },
        head: { fontWeight: 700, borderBottom: '2px solid #dee2e6' },
      },
    },
    MuiLink: {
      defaultProps: { underline: 'hover' },
      styleOverrides: { root: { color: LABOKLIN_RED, cursor: 'pointer' } },
    },
  },
});

export default laboklinTheme;
